//
// Logger util
// -----------

define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var utils = require('utils');
    var storage = require('util/storage.util');

    module.exports = {

        /**
         * Separate logging by env
         * @type {boolean}
         */
        _isLoggingEnabled: function() {
            const searchParams = new URLSearchParams(window.location.search);

            return storage.local.getItem('isLoggerEnabled') || searchParams.get('isLoggerEnabled') === '1' || false;
        },

        /**
         * Logger proxy object
         * @private
         */
        _log: function(type, args) {
            args = utils.deepClone(_.toArray(args));

            if (this._isLoggingEnabled()) {

                type = type === 'message' ? 'log' : type;

                /* eslint-disable no-console */
                if (!(window.console && console[type] && console[type].apply)) {
                    return;
                }

                switch (type) {
                    case 'info':
                        console.info.apply(console, args);
                        break;
                    case 'warn':
                        console.warn.apply(console, args);
                        break;
                    case 'error':
                        console.error.apply(console, args);
                        break;
                    default:
                        console.log.apply(console, args);
                }
                /* eslint-enable no-console */
            }
        },

        /**
         * Native console.log wrapper
         */
        log: function() {
            this._log('log', arguments);
        },

        /**
         * Native console.info wrapper
         */
        info: function() {
            this._log('info', arguments);
        },

        /**
         * Native console.warn wrapper
         */
        warn: function() {
            this._log('warn', arguments);
        },

        /**
         * Native console.error wrapper
         */
        error: function() {
            this._log('error', arguments);
        },

        /**
         * Handle server messages
         * @param  {Object} data
         * @param  {string} type    ['send', 'received', 'error', 'network']
         */
        message: function(data, type) {
            type = type ? type : '';

            var args = {};

            switch (type) {
                case 'send':
                    args = {
                        data: data,
                        message: 'Send',
                        color: '#1E88E5'
                    };
                    break;
                case 'received':
                    args = {
                        data: data,
                        message: 'Received',
                        color: '#43A047'
                    };
                    break;
                case 'pasSend':
                    args = {
                        data: data,
                        message: 'PAS Send',
                        color: '#9c27b0'
                    };
                    break;
                case 'pasReceived':
                    args = {
                        data: data,
                        message: 'PAS Received',
                        color: '#58b897'
                    };
                    break;
                case 'error':
                    args = {
                        data: data,
                        message: 'Error',
                        color: '#E53935'
                    };
                    break;
                case 'network':
                    args = {
                        data: data,
                        message: 'Network error',
                        color: '#E53935'
                    };
                    break;
                case 'push':
                    args = {
                        data: data,
                        message: 'Push',
                        color: '#546E7A'
                    };
                    break;
                case 'unknownPush': {
                    args = {
                        data: data,
                        message: 'Push',
                        color: '#887F9B'
                    };
                    break;
                }
                default: {
                    args = {
                        data: data,
                        message: 'Unknown',
                        color: '#ACACAC'
                    };
                }
            }

            this._log('message', [
                '%c [%s %s]: %O | %s | %s',
                'color:' + args.color,
                args.message,
                args.data.ID,
                args.data,
                args.data.description || 'description not found',
                window.Playtech.API.formatter.getDateTimeLongMs(new Date())
            ]);
        }

    };
});
